import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styles from '../styles/components/PageTransition.module.css';

/**
 * Wraps routed page content so arriving at a new route feels like an
 * actual transition rather than an instant swap. Re-keys on pathname
 * so React remounts the inner node and the CSS entrance animation
 * (fade + slight upward slide) replays every time.
 *
 * Respects prefers-reduced-motion via the stylesheet itself.
 */
const PageTransition = ({ children }) => {
  const location = useLocation();
  const [displayKey, setDisplayKey] = useState(location.pathname);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    setDisplayKey(location.pathname);
  }, [location.pathname]);

  return (
    <div key={displayKey} className={styles.pageEnter}>
      {children}
    </div>
  );
};

export default PageTransition;